import { render, staticRenderFns } from "./TabBar.vue?vue&type=template&id=53d2d368&scoped=true&"
import script from "./TabBar.vue?vue&type=script&lang=ts&"
export * from "./TabBar.vue?vue&type=script&lang=ts&"
import style0 from "./TabBar.vue?vue&type=style&index=0&id=53d2d368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d2d368",
  null
  
)

export default component.exports